import { LoadingScreen } from '@cabonline/ui-web';
import { isValidAuthCode, logger, sanitizeRedirectUrl, useAuth } from '@multiplatform-apps/service-trips';
import { paths } from '../../constants';
import { getCurityRedirectUri } from '../../utils';
import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export const AuthCallback = (): React.JSX.Element => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { verifyCode } = useAuth();

  useEffect(() => {
    const code = params.get('code');
    const state = params.get('state');
    if (!code || !isValidAuthCode(code)) {
      logger.error('Missing or invalid code in auth callback params');
      navigate(paths.login);
    } else {
      const redirectUri = getCurityRedirectUri();
      const postLoginRedirect = sanitizeRedirectUrl(
        params.get('redirect') ?? paths.trips.root,
        window.location.origin
      );
      verifyCode(code, redirectUri, state ?? undefined)
        .then(() => {
          navigate(postLoginRedirect);
        })
        .catch((error: unknown) => {
          logger.error('Auth callback error', error);
          navigate(`${paths.login}?error=auth_error`);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <LoadingScreen />;
};
